import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spinner from '../../components/Spinner';

const CirlePlus = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  > div:nth-of-type(1) {
    position: relative;
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
    border-radius: 50%;
    > span {
      position: absolute;
      left: 3px;
      font-family: serif;
      text-decoration: none;
    }
  }
  > div:nth-of-type(2) {
    font-size: 14px;
  }
`;
const AccordionParent = CirlePlus.extend`
  margin-left: 10px;
  color: ${({ isShow }) => (isShow ? '#000' : '#FFF')};
  > div:nth-of-type(1) {
    width: 24px;
    height: 24px;
    > span {
      top: ${({ isShow }) => (isShow ? '-3px' : '-1px')};
      font-size: ${({ isShow }) => (isShow ? '44px' : '24px')};
    }
  }
`;

const AccordionChild = CirlePlus.extend`
  color: '#000';
  margin-left: 0;
  > div:nth-of-type(1) {
    border: ${({ noBorder, isShowChild }) => {
      if (noBorder) return 'none';
      if (isShowChild) return '1px solid #000';
      return '1px solid #FFF';
    }};
    > span {
      top: ${({ isShowChild }) => (isShowChild ? '-3px' : '-1px')};
      font-size: ${({ isShowChild }) => (isShowChild ? '44px' : '24px')};
    }
  }
`;

const IconBase = ({ isPlus, color }) => (
  <React.Fragment>
    {isPlus ? (
      <svg fill={color} id="plus" data-name="plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>plus</title>
        <path
          d="M304,263.19a11,11,0,1,1-11,11,11,11,0,0,1,11-11m0-1a12,12,0,1,0,12,12,12,12,0,0,0-12-12Z"
          transform="translate(-291.98 -262.19)"
        />
        <rect x="6" y="11" width="12" height="2" />
        <rect x="11" y="6" width="2" height="12" />
      </svg>
    ) : (
      <svg fill={color} id="plus" data-name="plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>minus</title>
        <path
          d="M304,263.19a11,11,0,1,1-11,11,11,11,0,0,1,11-11m0-1a12,12,0,1,0,12,12,12,12,0,0,0-12-12Z"
          transform="translate(-291.98 -262.19)"
        />
        <rect x="6" y="11" width="12" height="2" />
      </svg>
    )}
  </React.Fragment>
);

const ChildIconBase = ({ isPlus, color }) => (
  <React.Fragment>
    {isPlus ? (
      <svg id="plus" width="16" height="16" data-name="plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <title>sp_plus</title>
        <rect y="22" width="52" height="8" />
        <rect x="22" width="8" height="52" />
      </svg>
    ) : (
      <svg id="minus" width="16" height="16" data-name="minus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 8">
        <title>sp_minus</title>
        <rect width="52" height="8" />
      </svg>
    )}
  </React.Fragment>
);

const AccordionTitle = ({ isShow, noBorder, title, isShowChild, type, isLoading }) => (
  <React.Fragment>
    {type === 'child' ? (
      <AccordionChild isShowChild={isShowChild} noBorder={noBorder}>
        <div>{isShowChild ? <ChildIconBase isPlus={false} /> : <ChildIconBase isPlus />}</div>
        <div>{title}</div>
        {(() => {
          if (isLoading === true) {
            return (
              <div style={{ marginLeft: '10px' }}>
                <Spinner c="black" show={isLoading} />
              </div>
            );
          }
          return '';
        })()}
      </AccordionChild>
    ) : (
      <AccordionParent isShow={(isShow !== undefined && isShow) || false}>
        <div>
          {(isShow !== undefined && isShow) || false ? (
            <IconBase isPlus={false} color="#000000" />
          ) : (
            <IconBase isPlus color="#ffffff" />
          )}
        </div>
        <div>{title}</div>
      </AccordionParent>
    )}
  </React.Fragment>
);

AccordionTitle.defaultProps = {
  title: '',
  type: 'parent',
  isShow: false,
  isShowChild: false,
  noBorder: false,
  isLoading: false,
};

AccordionTitle.propTypes = {
  isShow: PropTypes.bool,
  isShowChild: PropTypes.bool,
  noBorder: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default AccordionTitle;



// WEBPACK FOOTER //
// ./src/pages/SalonList/AccordionTitle.js